import MenuLinkWrapper from "../MenuLinkWrapper/MenuLinkWrapper";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import { ReportingOptionIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import createAbsolutePath from "createAbsolutePath";

const ReportingMenuLink = () => {
  return (
    <MenuLinkWrapper
      href={createAbsolutePath("/ra/reports/retail_sales")}
      id={ReportingOptionIds.ReportingTrigger}
      data-testid={ReportingOptionIds.ReportingTrigger}
    >
      {messages.reporting}
    </MenuLinkWrapper>
  );
};

export default ReportingMenuLink;
